import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GoogleAnalyticsConfigurationState, GoogleAnalyticsConfigurationStateConst } from 'src/app/AppState';

export const getGoogleAnalyticsConfigurationState = createFeatureSelector<GoogleAnalyticsConfigurationState>(GoogleAnalyticsConfigurationStateConst);

export const getGoogleAnalyticsConfiguration = createSelector(
    getGoogleAnalyticsConfigurationState,
    (state: GoogleAnalyticsConfigurationState) => state.GoogleAnalyticsConfiguration
);